(() => {
 if (customElements.get('alva-holiday-price')) return;
 customElements.define('alva-holiday-price', class extends HTMLElement {
  connectedCallback() {
   this.listeners?.abort();
   this.listeners = new AbortController();
   this.templates = new Map([...this.querySelectorAll('template[data-variant]')].map(template => [template.dataset.variant, template]));
   this.queue = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.isConnected) this.update(); });
   };
   const options = {signal: this.listeners.signal};
   document.addEventListener('variant:change', event => {
    if (event.detail?.formId === this.dataset.form || event.target?.id === this.dataset.form) this.queue();
   }, options);
   document.addEventListener('change', event => {
    // Native hidden-variant input updates, not unrelated forms or option clicks.
    if (event.target?.name === 'id' && event.target.form?.id === this.dataset.form) this.queue();
   }, options);
   document.addEventListener('alva:pdp:render', event => {
    const components = event.detail?.components;
    if (!components || components.includes('purchase') || components.includes('content')) this.queue();
   }, options);
   document.addEventListener('alva:pdp:prices', event => {
    const row = this.closest('.product-info')?.querySelector('.alva-price-row');
    if (String(event.detail?.variant) === row?.dataset.alvaPriceVariant) this.queue();
   }, options);
   window.addEventListener('pageshow', this.queue, options);
   this.update();
  }
  update() {
   if (Date.now() >= Date.parse(this.dataset.end)) { this.hidden = true; this.dataset.active = 'false'; return; }
   const root = this.closest('.product-info');
   const row = root?.querySelector('.alva-price-row');
   const form = document.getElementById(this.dataset.form);
   const id = row?.dataset.alvaPriceVariant || form?.querySelector('[name="id"]')?.value || this.dataset.default;
   const template = this.templates.get(String(id));
   const text = this.querySelector('.alva-holiday-price__text');
   if (!template || !text) return;
   const active = template.dataset.eligible === 'true' ? 'true' : 'false';
   if (this.dataset.active !== active) this.dataset.active = active;
   if (this.dataset.renderedVariant !== id) {
    text.replaceChildren(template.content.cloneNode(true));
    this.dataset.renderedVariant = id;
   }
  }
  disconnectedCallback() {
   this.listeners?.abort();
   cancelAnimationFrame(this.frame);
   this.frame = 0;
  }
 });
})();
